import SubjectList from './SubjectList';

export default SubjectList; 